/** Display label when caller name is missing (matches backend auto-case fallback). */
export const UNKNOWN_CALLER_LABEL = 'Unknown Caller';

export function formatCallerDisplayName(
  name?: string | null,
  unknownLabel = UNKNOWN_CALLER_LABEL
): string {
  const trimmed = name?.trim();
  return trimmed ? trimmed : unknownLabel;
}

// Constants for workspace IDs
export const WORKSPACE_IDS = [34442, 23378, 19699] as const;

// Utility function to get random workspace ID
export const getRandomWorkspaceId = (): string => {
  const randomIndex = Math.floor(Math.random() * WORKSPACE_IDS.length);
  return WORKSPACE_IDS[randomIndex].toString();
};
